import React from "react";
import ReactDOM from "react-dom";

import "./index.scss";
import App from "./App";
import Tokens from "./store/tokens";
import FavoriteMovies from "./store/favorites";
import Message from "./store/message";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <Message.Provider>
      <Tokens.Provider>
        <FavoriteMovies.Provider>
          <App />
        </FavoriteMovies.Provider>
      </Tokens.Provider>
    </Message.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
